// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M9coclbB {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: fixed;
  right: 1rem;
  bottom: 20%;
  z-index: 1000;
  width: 8rem;
  height: 8rem;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease, -webkit-transform 0.2s ease;
  transition: opacity 0.2s ease, -webkit-transform 0.2s ease;
  transition: transform 0.2s ease, opacity 0.2s ease;
  transition: transform 0.2s ease, opacity 0.2s ease, -webkit-transform 0.2s ease;
}
.M9coclbB:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}
.M9coclbB:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .M9coclbB {
    right: 0.5rem;
    bottom: 8.5rem;
    width: 4rem;
    height: 4rem;
  }
}
@media (max-width: 767px) {
  .uv5uPJmv {
    bottom: 5.75rem;
  }
}
.s6Y9xHqw {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: contain;
     object-fit: contain;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomerServiceFab/CustomerServiceFab.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;ECsGE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;EDzGA,eAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,kEAAA;EAAA,0DAAA;EAAA,kDAAA;EAAA,+EAAA;AACF;AACE;EACE,8BAAA;UAAA,sBAAA;AACJ;AAEE;EACE,8BAAA;UAAA,sBAAA;AAAJ;AClBE;EAAA;IDsBE,aAAA;IACA,cAAA;IACA,WAAA;IACA,YAAA;EAAF;AACF;AC1BE;EAAA;ID+BE,eAAA;EADF;AACF;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;EACA,oBAAA;AAFF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.fab {\n  .button-reset();\n  position: fixed;\n  right: @spacing-md;\n  bottom: 20%;\n  z-index: @z-index-dropdown;\n  width: 8rem;\n  height: 8rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    right: @spacing-sm;\n    bottom: 8.5rem;\n    width: 4rem;\n    height: 4rem;\n  });\n}\n\n.fabHome {\n  .mobile({\n    bottom: 5.75rem;\n  });\n}\n\n.fabImg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n  pointer-events: none;\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fab": `M9coclbB`,
	"fabHome": `uv5uPJmv`,
	"fabImg": `s6Y9xHqw`
};
export default ___CSS_LOADER_EXPORT___;
